import { Accept } from 'react-dropzone';
import { useFormContext } from 'react-hook-form';

import { RHFUpload } from 'src/components/hook-form';

interface ICasRHFDropzoneSingleUpload {
  name: string;
  accept?: Accept;
}

export default function CasRHFDropzoneSingleUpload({ name, accept }: ICasRHFDropzoneSingleUpload) {
  const { setValue } = useFormContext();

  const onDrop = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    const newFile = Object.assign(file, { preview: URL.createObjectURL(file) });
    if (file) setValue(name, newFile, { shouldValidate: true });
  };

  const onDelete = () => setValue(name, null);

  return <RHFUpload name={name} accept={accept} onDrop={onDrop} onDelete={onDelete} />;
}
